import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../firebase';
import { Box, CircularProgress, Typography } from '@mui/material';

export default function TournamentRedirect() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    const resolve = async () => {
      try {
        const snap = await getDocs(query(collection(db, 'tournaments'), where('slug', '==', slug)));
        if (snap.empty) {
          setError('Tournament not found.');
          return;
        }
        const tid = snap.docs[0].id;
        navigate(`/tournament/${tid}`, { replace: true });
      } catch (e) {
        setError('Failed to load tournament.');
      }
    };
    resolve();
  }, [slug, navigate]);

  if (error) return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', gap: 2 }}>
      <Typography variant="h5" color="error">{error}</Typography>
      <Typography variant="body2" sx={{ color: '#888' }}>The tournament link may be invalid or expired.</Typography>
    </Box>
  );

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
      <CircularProgress />
    </Box>
  );
}
